export function SellIcon(): JSX.Element {
  return (
    <svg
      width="39"
      height="39"
      viewBox="0 0 39 39"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.7883 18.5452L20.4396 4.19641C19.8383 3.59516 19.0096 3.25391 18.1483 3.25391H6.49707C4.70957 3.25391 3.24707 4.71641 3.24707 6.50391V18.1552C3.24707 19.0164 3.58832 19.8452 4.20582 20.4464L18.5546 34.7952C19.8221 36.0627 21.8858 36.0627 23.1533 34.7952L34.8046 23.1439C36.0721 21.8764 36.0721 19.8289 34.7883 18.5452ZM10.5596 13.0039C9.21082 13.0039 8.12207 11.9152 8.12207 10.5664C8.12207 9.21766 9.21082 8.12891 10.5596 8.12891C11.9083 8.12891 12.9971 9.21766 12.9971 10.5664C12.9971 11.9152 11.9083 13.0039 10.5596 13.0039Z"
        fill="#D44A74"
      />
    </svg>
  );
}
